// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__b5DCb","toggle":"styles_toggle__1XDoR","preview":"styles_preview__3_1lQ"};